import { FC, useMemo } from 'react';
import { CategoryOverviewSection } from '../../modules/endUserCategoryOverview/components/CategoryOverviewSection';
import { ProductRecommendationList } from '../../modules/endUserProductRecommendation/components/ProductRecommendationList';
import { StatusLevelSection } from '../../modules/endUserStatusLevel/components/StatusLevelSection';
import { BenefitsSection } from '../../modules/endUserBenefits/components/BenefitsSection';
import { EndUserHouseModel } from '../../modules/endUserHouseModel/components/EndUserHouseModel';
import { useAppSelector } from '../../lib/store/hooks';
import { NewHouseModel } from '../../modules/endUserHouseModelNew/components/NewHouseModel';
import { EndUserDemandAreaTiles } from '../../modules/EndUserDemandAreaTiles';
import { useApplyCampaignHouseBadge } from '../../lib/hooks/endUserHooks/useApplyCampaignHouseBadge';
import { useApplyCampaignTeaser } from '../../lib/hooks/endUserHooks/useApplyCampaignTeaser';
import { CampaignTeaser } from '../../modules/endUserCampaignTeaser/components/CampaignTeaser';
import { useIsEviTenant } from '../../lib/hooks/endUserHooks/useIsEviTenant';
import { EviNewHouseModel } from '../../components/EviNewHouseModel';

export const EndUserHomePage: FC = () => {
  const { tenantAndProject, isGuestMode } = useAppSelector(({ endUser }) => endUser);

  const applyNewDesign =
    tenantAndProject?.subDomain === 'demo-company' &&
    tenantAndProject?.tenantId === 11289;

  const isPreprodEnergieSwaben =
    tenantAndProject?.domain === 'preprod.hausversorger.de' &&
    tenantAndProject?.tenantId === 11005;

  const applyNewHouse =
    (tenantAndProject?.subDomain === 'energie-schwaben' &&
      tenantAndProject?.tenantId === 11002) ||
    isPreprodEnergieSwaben;

  const applyCampaignHouseBadge = useApplyCampaignHouseBadge();
  const campaignTeaserSettings = useApplyCampaignTeaser();
  const isEviTenant = useIsEviTenant();

  //hardcode for this tenants
  const node = useMemo(() => {
    if (tenantAndProject?.subDomain === 'energie-schwaben' || isPreprodEnergieSwaben) {
      return (
        <>
          {applyNewHouse ? (
            <NewHouseModel applyCampaignHouseBadge={applyCampaignHouseBadge} />
          ) : (
            <EndUserHouseModel applyCampaignHouseBadge={applyCampaignHouseBadge} />
          )}
          <CampaignTeaser
            campaignTeaserSettings={campaignTeaserSettings}
            isGuestMode={isGuestMode}
          />
          <ProductRecommendationList />
          <CategoryOverviewSection />
          <BenefitsSection />
        </>
      );
    } else if (applyNewDesign) {
      return (
        <>
          <EndUserDemandAreaTiles applyCampaignHouseBadge={applyCampaignHouseBadge} />
          <CampaignTeaser
            campaignTeaserSettings={campaignTeaserSettings}
            isGuestMode={isGuestMode}
          />
          <StatusLevelSection />
          <CategoryOverviewSection />
          <ProductRecommendationList />
          <BenefitsSection />
        </>
      );
    } else if (isEviTenant) {
      return (
        <>
          <EviNewHouseModel applyCampaignHouseBadge={applyCampaignHouseBadge} />
          <CampaignTeaser
            campaignTeaserSettings={campaignTeaserSettings}
            isGuestMode={isGuestMode}
          />
          <StatusLevelSection />
          <CategoryOverviewSection />
          <ProductRecommendationList />
          <BenefitsSection />
        </>
      );
    } else {
      return (
        <>
          <EndUserHouseModel applyCampaignHouseBadge={applyCampaignHouseBadge} />
          <CampaignTeaser
            campaignTeaserSettings={campaignTeaserSettings}
            isGuestMode={isGuestMode}
          />
          <StatusLevelSection />
          <CategoryOverviewSection />
          <ProductRecommendationList />
          <BenefitsSection />
        </>
      );
    }
  }, [
    applyCampaignHouseBadge,
    applyNewDesign,
    applyNewHouse,
    campaignTeaserSettings,
    isEviTenant,
    isGuestMode,
    isPreprodEnergieSwaben,
    tenantAndProject?.subDomain,
  ]);

  return node;
};
